export enum MentionMePlace {
    dashboard = 'dashboard',
    refereefind = 'refereefind',
    referreroffer = 'referreroffer',
    conversionmessage = 'conversionmessage',
    order = 'order'
}

export type TMentionMeSituation = 'checkout' | 'homepage' | 'landingpage' | 'dashboard' | 'cart' | 'postpurchase';
export type TMentionMeImplementation = 'embed' | 'popup' | 'banner' | 'overlay' | 'link';

export interface IMentionMeCommonParams {
    locale: string;
    implementation?: string;
}

export interface IMentionMeDashboardParams extends IMentionMeCommonParams {
    situation: string;
    firstname: string;
    surname: string;
    customer_id?: number;
    email: string;
}

export interface IMentionMeRefereefindParams extends IMentionMeCommonParams {
    situation: string;
}

export interface IMentionMeOrderParams extends IMentionMeCommonParams {
    customer_id: number;
    email: string;
    segment: string;
    order_number: string;
    order_total: number;
    order_currency: string;
    order_date: string;
}

export interface IMentionMeConversionmessageParams extends IMentionMeCommonParams {
    situation: string;
}

export interface IMentionMeReferrerofferParams extends IMentionMeOrderParams {
    situation: string;
    firstname: string;
    surname: string;
}
